import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'

export const RightPanel = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()

  const date = data.createDate

  return (
    <Element style={{ color: '#3A414B' }}>
      <Translate value="alertDetail.DATE" />
      :&nbsp;
      <span>{formatDateTime(date, FORMAT.DATE, locale, timezone)}</span>
    </Element>
  )
}
